'use strict';

var accentColors = {};

exports.__exports = accentColors;
//# sourceMappingURL=accentColors2.cjs.map
